var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c(
        "b-modal",
        {
          attrs: { id: "confirm-modal" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("insert.order.doYouConfirm")) +
                      "\n    "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c("CancelButton", {
                    staticClass: "float-right ml-2",
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancelSelectedItems($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "success" },
                      on: { click: _vm.confirmSelectedItems }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.okay")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("insert.discount.listWillBeDeleted")) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "confirm-branch-modal",
            "no-close-on-backdrop": "",
            "hide-header-close": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("insert.order.doYouConfirm")) +
                      "\n    "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c("CancelButton", {
                    staticClass: "float-right ml-2",
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancelSelectBranchCriteria($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "success" },
                      on: { click: _vm.confirmSelectBranchCriteria }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.okay")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("insert.discount.customersAndRoutesWillBeDeleted")
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Discount" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Code",
                        error: _vm.$v.form.Code,
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1,
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "DiscountBeginDate",
                        error: _vm.$v.form.DiscountBeginDate,
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: {
                          disabled: _vm.insertReadonly.DiscountBeginDate
                        },
                        model: {
                          value: _vm.form.DiscountBeginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "DiscountBeginDate", $$v)
                          },
                          expression: "form.DiscountBeginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "DiscountEndDate",
                        error: _vm.$v.form.DiscountEndDate,
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.DiscountEndDate },
                        model: {
                          value: _vm.form.DiscountEndDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "DiscountEndDate", $$v)
                          },
                          expression: "form.DiscountEndDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        lg: "2"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.discount.general"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DiscountTypeId",
                            error: _vm.$v.form.DiscountTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextDiscount/api/DiscountType/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "DiscountTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedDiscountType,
                              callback: function($$v) {
                                _vm.selectedDiscountType = $$v
                              },
                              expression: "selectedDiscountType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DiscountKindId",
                            error: _vm.$v.form.DiscountKindId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextDiscount/api/DiscountKind/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "DiscountKindId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedDiscountKind,
                              callback: function($$v) {
                                _vm.selectedDiscountKind = $$v
                              },
                              expression: "selectedDiscountKind"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "MaxValue",
                            error: _vm.$v.form.MaxValue
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.form.ApplyToTimes !== 1
                            },
                            model: {
                              value: _vm.form.MaxValue,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "MaxValue", $$v)
                              },
                              expression: "form.MaxValue"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BranchCriteriaId",
                            error: _vm.$v.form.BranchCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "lookup-key": "BRANCH_CRITERIA",
                              disabled: _vm.distributionTypeControl
                            },
                            on: {
                              input: function($event) {
                                _vm.selectedType("BranchCriteriaId", $event)
                                _vm.setBranchCriteria($event)
                              }
                            },
                            model: {
                              value: _vm.branchCriteria,
                              callback: function($$v) {
                                _vm.branchCriteria = $$v
                              },
                              expression: "branchCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerCriteriaId",
                            error: _vm.$v.form.CustomerCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { "lookup-key": "CUSTOMER_CRITERIA" },
                            on: {
                              input: function($event) {
                                _vm.selectedType("CustomerCriteriaId", $event)
                                _vm.setCustomerCriteria($event)
                              }
                            },
                            model: {
                              value: _vm.customerCriteria,
                              callback: function($$v) {
                                _vm.customerCriteria = $$v
                              },
                              expression: "customerCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteCriteriaId",
                            error: _vm.$v.form.RouteCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { "lookup-key": "ROUTE_CRITERIA" },
                            on: {
                              input: function($event) {
                                _vm.selectedType("RouteCriteriaId", $event)
                                _vm.setRouteCriteria($event)
                              }
                            },
                            model: {
                              value: _vm.routeCriteria,
                              callback: function($$v) {
                                _vm.routeCriteria = $$v
                              },
                              expression: "routeCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PaymentCriteriaId",
                            error: _vm.$v.form.PaymentCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { "lookup-key": "PAYMENT_CRITERIA" },
                            on: {
                              input: function($event) {
                                _vm.selectedType("PaymentCriteriaId", $event)
                                _vm.setPaymentCriteria($event)
                              }
                            },
                            model: {
                              value: _vm.paymentCriteria,
                              callback: function($$v) {
                                _vm.paymentCriteria = $$v
                              },
                              expression: "paymentCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Genexp1",
                            error: _vm.$v.form.Genexp1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Genexp1
                            },
                            model: {
                              value: _vm.form.Genexp1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Genexp1", $$v)
                              },
                              expression: "form.Genexp1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FinanceCode",
                            error: _vm.$v.form.FinanceCode
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.FinanceCode
                            },
                            model: {
                              value: _vm.form.FinanceCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "FinanceCode", $$v)
                              },
                              expression: "form.FinanceCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BudgetId",
                            error: _vm.$v.form.BudgetId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextBudget/api/BudgetMaster/Search",
                              disabled: !_vm.form.UseBudget
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "BudgetId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.budget,
                              callback: function($$v) {
                                _vm.budget = $$v
                              },
                              expression: "budget"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BudgetAmount",
                            error: _vm.$v.form.BudgetAmount
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              disabled: !_vm.form.UseBudget,
                              type: "text"
                            },
                            model: {
                              value: _vm.form.BudgetAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "BudgetAmount", $$v)
                              },
                              expression: "form.BudgetAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveStateId",
                            error: _vm.$v.form.ApproveStateId
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.ApproveStateLabel,
                              callback: function($$v) {
                                _vm.ApproveStateLabel = $$v
                              },
                              expression: "ApproveStateLabel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "DiscountCategoryId",
                            error: _vm.$v.form.DiscountCategoryId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextDiscount/api/DiscountCategory/Search"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "DiscountCategoryId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.discountCategory,
                              callback: function($$v) {
                                _vm.discountCategory = $$v
                              },
                              expression: "discountCategory"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BranchSharePercent",
                            error: _vm.$v.form.BranchSharePercent
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.distributionTypeControl,
                              maxLength: "6",
                              oninput: _vm.maxLengthControl
                            },
                            model: {
                              value: _vm.form.BranchSharePercent,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "BranchSharePercent", $$v)
                              },
                              expression: "form.BranchSharePercent"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "MaxUsage",
                            error: _vm.$v.form.MaxUsage
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.MaxUsage
                            },
                            model: {
                              value: _vm.form.MaxUsage,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "MaxUsage", $$v)
                              },
                              expression: "form.MaxUsage"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TciBreak1Id",
                            error: _vm.$v.form.TciBreak1Id
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { "lookup-key": "TCI_BREAKDOWN" },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("TciBreak1Id", $event)
                              }
                            },
                            model: {
                              value: _vm.tciBreak1,
                              callback: function($$v) {
                                _vm.tciBreak1 = $$v
                              },
                              expression: "tciBreak1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseBudget",
                            error: _vm.$v.form.UseBudget
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.UseBudget
                            },
                            on: {
                              input: function($event) {
                                return _vm.useBudgetEvent($event)
                              }
                            },
                            model: {
                              value: _vm.form.UseBudget,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UseBudget", $$v)
                              },
                              expression: "form.UseBudget"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsCascade",
                            error: _vm.$v.form.IsCascade
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsCascade
                            },
                            model: {
                              value: _vm.form.IsCascade,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsCascade", $$v)
                              },
                              expression: "form.IsCascade"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseMultiGiven",
                            error: _vm.$v.form.UseMultiGiven
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.UseMultiGiven
                            },
                            model: {
                              value: _vm.form.UseMultiGiven,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UseMultiGiven", $$v)
                              },
                              expression: "form.UseMultiGiven"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsMandatory",
                            error: _vm.$v.form.IsMandatory
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsMandatory
                            },
                            model: {
                              value: _vm.form.IsMandatory,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsMandatory", $$v)
                              },
                              expression: "form.IsMandatory"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsDoubleScore",
                            error: _vm.$v.form.IsDoubleScore
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.IsDoubleScore
                            },
                            model: {
                              value: _vm.form.IsDoubleScore,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsDoubleScore", $$v)
                              },
                              expression: "form.IsDoubleScore"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApplyToTimes",
                            error: _vm.$v.form.ApplyToTimes,
                            md: "4",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.ApplyToTimes
                            },
                            model: {
                              value: _vm.form.ApplyToTimes,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ApplyToTimes", $$v)
                              },
                              expression: "form.ApplyToTimes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    lazy: "",
                    title: _vm.$t("insert.discount.discountTakens"),
                    disabled: !_vm.form.DiscountKindId
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: {
                      items: _vm.discountTakenItems,
                      "main-form": _vm.form,
                      "show-edit": false
                    },
                    model: {
                      value: _vm.form.DiscountTakens,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "DiscountTakens", $$v)
                      },
                      expression: "form.DiscountTakens"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    lazy: "",
                    title: _vm.$t("insert.discount.discountGivens"),
                    disabled: _vm.form.DiscountKindId === 6
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: {
                      items: _vm.discountGivenItems,
                      "main-form": _vm.form,
                      "show-edit": false,
                      "before-add": _vm.beforeAddDiscountGivens
                    },
                    model: {
                      value: _vm.form.DiscountGivens,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "DiscountGivens", $$v)
                      },
                      expression: "form.DiscountGivens"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    lazy: "",
                    title: _vm.$t("insert.discount.discountExcludedCustomers")
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: {
                      items: _vm.discountExcludedCustomerItems,
                      "main-form": _vm.form,
                      "show-edit": false
                    },
                    model: {
                      value: _vm.form.DiscountExcludedCustomers,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "DiscountExcludedCustomers", $$v)
                      },
                      expression: "form.DiscountExcludedCustomers"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.customerCriterTabValid
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.discount.customerCriterias")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.discountDetailsCustomerCriteriaItems,
                          "main-form": _vm.form,
                          "show-edit": false
                        },
                        model: {
                          value: _vm.customerCriterias,
                          callback: function($$v) {
                            _vm.customerCriterias = $$v
                          },
                          expression: "customerCriterias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.branchTabValid
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.discount.branchs")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.discountDetailsBranchItems,
                          "main-form": _vm.form,
                          "show-edit": false
                        },
                        model: {
                          value: _vm.form.branchs,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "branchs", $$v)
                          },
                          expression: "form.branchs"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerTabValid
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.discount.discountCustomers"),
                        disabled: !_vm.form.BranchCriteriaId
                      },
                      on: {
                        click: function($event) {
                          return _vm.DiscountCustomersValid()
                        }
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.getDiscountCustomerItems(),
                          "main-form": _vm.form,
                          "show-edit": false
                        },
                        model: {
                          value: _vm.customers,
                          callback: function($$v) {
                            _vm.customers = $$v
                          },
                          expression: "customers"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.routeTabValid
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.discount.routes"),
                        disabled: !_vm.form.BranchCriteriaId
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.discountDetailsRouteItems,
                          "main-form": _vm.form,
                          "show-edit": false
                        },
                        model: {
                          value: _vm.routes,
                          callback: function($$v) {
                            _vm.routes = $$v
                          },
                          expression: "routes"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.paymentTabValid
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.discount.payments"),
                        disabled: !_vm.form.BranchCriteriaId
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.discountDetailsPaymentTypeItems,
                          "main-form": _vm.form,
                          "show-edit": false
                        },
                        model: {
                          value: _vm.paymentTypes,
                          callback: function($$v) {
                            _vm.paymentTypes = $$v
                          },
                          expression: "paymentTypes"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerSqlsTabValid
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.discount.discountCustomerSqls")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.discountCustomerSqlItems,
                          "main-form": _vm.form,
                          "show-edit": false
                        },
                        model: {
                          value: _vm.form.DiscountCustomerSqls,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "DiscountCustomerSqls", $$v)
                          },
                          expression: "form.DiscountCustomerSqls"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01e91ed3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e91ed3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Discount/insert.vue
// module id = null
// module chunks = 